import { render, staticRenderFns } from "./DashboardUserBengkulu.vue?vue&type=template&id=09b23d10&lang=pug"
import script from "./DashboardUserBengkulu.vue?vue&type=script&lang=js"
export * from "./DashboardUserBengkulu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports